"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdminToolSlugDisplay = exports.getCategorySuperCategory = void 0;

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var Category = _interopRequireWildcard(require("../constants/groupTags/Category"));

var SuperCategory = _interopRequireWildcard(require("../constants/groupTags/SuperCategory"));

var SuperCategoryGroup = _interopRequireWildcard(require("../constants/groupTags/superCategoryGroups"));

var CategorySlug = _interopRequireWildcard(require("../constants/urlSlugs/CategorySlug"));

var SuperCategorySlug = _interopRequireWildcard(require("../constants/urlSlugs/SuperCategorySlug"));

var superCategoryValues = Object.values(SuperCategory);
var getSuperCategoryGroupValues = (0, _memoize.default)(function (superCategory) {
  return Object.values(SuperCategoryGroup[superCategory] || {});
});
var getCategorySuperCategory = (0, _memoize.default)(function (category) {
  switch (category) {
    case Category.DATA_MANAGEMENT:
      return SuperCategory.MARKETING;

    case Category.LIVE_CHAT:
      return SuperCategory.MARKETING;

    case Category.VIDEO:
      return SuperCategory.MARKETING;

    default:
      return superCategoryValues.find(function (superCategory) {
        var superCategoryGroupValues = getSuperCategoryGroupValues(superCategory);
        return superCategoryGroupValues.includes(category);
      });
  }
});
exports.getCategorySuperCategory = getCategorySuperCategory;

var getAdminToolSlugDisplay = function getAdminToolSlugDisplay(category, slug) {
  var superCategory = getCategorySuperCategory(category);
  return "/" + SuperCategorySlug[superCategory] + "/" + CategorySlug[category] + "/" + slug;
};

exports.getAdminToolSlugDisplay = getAdminToolSlugDisplay;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/groupTags.js
// module id = 219
// module chunks = 209 210 211 212 213